import { fetchGet } from '../helperApi'

export const fetchCustomerContractsApi = (companyId, customerId, params) => {
    return fetchGet(`company/${companyId}/customers/${customerId}/contracts`, params)
}

export const fetchCustomerContractsLiveSearchApi = (customerId, params) => {
    return fetchGet(`inspections/filters/live/contracts/customers/${customerId}`, params)
}
